import EdiDisplayUserMode from 'sites/components/display/EdiDisplayUserMode.vue';
import { displayModesContentEditor, displayModesCompositionEditor, DISPLAY_MOBILE } from '@/modules/board/config';

const displayUserMode = {
  name: 'partner-mode',
  component: EdiDisplayUserMode,
  active: false,
  icon: 'attach_money',
};

displayModesContentEditor.additionalModes = [displayUserMode];
displayModesCompositionEditor.additionalModes = [displayUserMode];
// Modificar la variable contentDisplayModes para que solo muestre la opción de movil y la opción de abrir edición
// en nueva pestaña
displayModesContentEditor.displayModes = {
  [DISPLAY_MOBILE]: {
    modeId: DISPLAY_MOBILE,
    width: '375px',
    icon: 'phone_iphone',
  },
};
